import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LoadingModal from "../components/Modals/LoadingModal/LoadingModal";
import { useCustomer } from "../customHooks/useCustomer";
import { rememberCancellationFlowSource } from "../utils/cancellationFlowSource";

interface ProtectedCustomerMyAccountProps {
  children: any;
}

// If: customer logged in -> move to MyAccount (return children)
// else: redirect him to LoginPage

const ProtectedMyAccount: React.FC<ProtectedCustomerMyAccountProps> = ({
  children,
}) => {
  const fullURL = window.location.href;
  const baseURL = window.location.origin;
  const paramsOnly = fullURL.replace(baseURL, '');
  const { country } = useParams();
  const navigate = useNavigate();
  const { customerState } = useCustomer();

  // before the login redirect, so the support link's src survives any login
  rememberCancellationFlowSource();

  useEffect(() => {
    
    if (!customerState?.customerID) {
      const redirectUrl = encodeURIComponent(paramsOnly);
      
      navigate(`/${country}/login?redirect=${redirectUrl}`);
    }
  }, [customerState, country, navigate]);

  if (!customerState?.customerID) {
    return <LoadingModal /> //load until it navigates (this line happens pre useeffect)
  } else {
    return children;
  }
};

export default ProtectedMyAccount;
